import { Box, Divider, Tab, Tabs, Typography } from "@mui/material";
import React, { Fragment, ReactNode, SyntheticEvent, useEffect, useState } from "react";

import HeaderedFullHeightContainer from "@/components/headered-full-height-container";


export interface AppTabItem {
  value: any;
  label?: ReactNode;
  render: () => ReactNode;
  condition?: () => boolean;
}

export interface AppTabGroup {
  label?: ReactNode; // Название группы (можно не указывать)
  items: AppTabItem[];
}

const AppFullPageTabsWithGroups = ({
  defaultValue,
  groups = [],
  onTabChange,
}: {
  defaultValue?: any;
  groups?: AppTabGroup[];
  onTabChange?: (val: any) => void;
}) => {
  const [tabValue, setTabValue] = useState<any>(defaultValue);

  useEffect(() => {
    setTabValue(defaultValue);
  }, [defaultValue]);

  const handleChangeTab = (_event: SyntheticEvent<Element, Event>, value: any) => {
    onTabChange?.(value);
    setTabValue(value);
  };

  return (
    <HeaderedFullHeightContainer
      header={
        <Box
          display="flex"
          alignItems="flex-start"
          gap={4}
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          {groups.map((group, idx) => (
            <Fragment key={idx}>
              <Box display="flex" flexDirection="column" alignItems="center">
                {group.label && (
                  <Typography
                    color="textSecondary"
                    sx={{
                      /*textDecoration: "underline",*/ fontWeight: 500,
                      fontSize: "16px",
                    }}
                  >
                    {group.label}
                  </Typography>
                )}
                <Tabs
                  value={tabValue}
                  onChange={handleChangeTab}
                  sx={{
                    minHeight: 25,
                    "& .MuiTabs-flexContainer": {
                      minHeight: 25,
                    },
                    "& .MuiTabs-root": {
                      minHeight: 25,
                    },
                    // Убираем отступы у индикатора
                    "& .MuiTabs-indicator": {
                      height: 2, // или 0 если не нужен
                    },
                  }}
                >
                  {group.items
                    .filter((item) => !item.condition || item.condition())
                    .map((item) => (
                      <Tab
                        key={item.value}
                        label={item.label}
                        value={item.value}
                        //label={<Typography>{item.label}</Typography>}
                        sx={{
                          minHeight: 0,
                          paddingTop: 0,
                          paddingBottom: 0,
                          lineHeight: 1,
                        }}
                      />
                    ))}
                </Tabs>
              </Box>
              {idx < groups.length - 1 && (
                <Divider orientation="vertical" flexItem sx={{ mx: 2 }} />
              )}
            </Fragment>
          ))}
        </Box>
      }
    >
      <>
          {groups
            .flatMap((g) => g.items)
            .filter((item) => !item.condition || item.condition())
            .map((item) => (
              <Fragment key={item.value}>{item.value === tabValue && item.render()}</Fragment>
            ))}
      </>
    </HeaderedFullHeightContainer>
  );
};

export default AppFullPageTabsWithGroups;
